import styled from "@emotion/styled";
import { FlyerDetailPagePreviewPositionCell } from "../../styles/flyer-detail-page-preview-cell.styles";
import { BASE_COLORS } from "../../../../../../../../../../emotion-theme";

export const HostContainer = styled(FlyerDetailPagePreviewPositionCell)`
  background-color: ${BASE_COLORS.darkRed};
  &:hover {
    cursor: default;
  }
`;
